import { Box, Typography } from '@mui/material'
import React from 'react'
import moment from 'moment'
import './Style.css'

const Queries = ({ queries }) => {
  return (
    <div className="fieldset-legend">
      {queries?.length > 0 ? (
        <fieldset
          style={{
            borderRadius: '20px',
            marginBottom: '10px',
          }}
        >
          <legend
            style={{
              height: '32px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              top: '-16px',
            }}
          >
            {' '}
            <Typography className="">Queries</Typography>
          </legend>
          <Box style={{ padding: '0px 8px' }}>
            {queries.map((query) => (
              <Box key={query.id} style={{ display: 'flex', gap: 150 }}>
                <div
                  style={{
                    display: 'inline-block',
                    marginBottom: '10px',
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      width: '40%',
                      marginBottom: '5px',
                      fontWeight: '700',
                    }}
                  >
                    <strong>Q{query.id + '. '}</strong>
                    {query.question}
                  </Typography>

                  <Typography sx={{ fontStyle: 'italic' }} variant="caption">
                    <br />
                    {query.question_by}
                  </Typography>

                  <Typography sx={{ fontStyle: 'italic' }} variant="caption" display="block">
                    {' on ' + moment(new Date(query?.question_at)).format('DD MMM YYYY, hh:mm A')}
                  </Typography>
                </div>

                <div
                  style={{
                    display: 'inline-block',
                    marginBottom: '10px',
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      width: '40%',
                      marginBottom: '5px',
                      fontWeight: '700',
                    }}
                  >
                    <strong>A{query.id + '. '}</strong>
                    {query.answer === null ? 'Not yet answered' : query.answer}
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic' }} variant="caption">
                    <br />
                    {query.answer_by}
                  </Typography>
                  <Typography sx={{ fontStyle: 'italic' }} variant="caption" display="block">
                    {query.answer === null
                      ? null
                      : ' on ' + moment(new Date(query?.answer_at)).format('DD MMM YYYY, hh:mm A')}
                  </Typography>
                </div>
              </Box>
            ))}
          </Box>
        </fieldset>
      ) : null}
    </div>
  )
}

export default Queries
